import { first } from '@ckeditor/ckeditor5-utils';
export function createVideoViewElement(writer, modelElement, videoType) {
    const videoElement = writer.createContainerElement('video', {controls: true, controlslist: 'nodownload', class: 'nomediaplugin'});
    const sourceElement = writer.createEmptyElement('source', {src: modelElement.getAttribute('src')});

    writer.insert(writer.createPositionAt(videoElement, 0), sourceElement);

    const container = videoType === 'videoBlock' ?
        writer.createContainerElement('figure', { class: 'video' }) :
        writer.createContainerElement('span', { class: 'video-inline' });
    writer.insert(writer.createPositionAt(container, 0), videoElement);
    return container;
}
export function getVideoViewElementMatcher(editor, matchVideoType) {
    const videoUtils = editor.plugins.get('VideoUtils');
    const areBothVideoPluginsLoaded = editor.plugins.has('VideoInlineEditing') && editor.plugins.has('VideoBlockEditing');
    return element => {
        if (!videoUtils.isInlineVideoView(element) || !element.hasAttribute('src')) {
            return null;
        }
        // If just one of the plugins is loaded (block or inline), it will match all kinds of images.
        if (!areBothVideoPluginsLoaded) {
            return getPositiveMatchPattern(element);
        }
        const videoType = element.findAncestor(videoUtils.isBlockVideoView) ? 'videoBlock' : 'videoInline';
        if (videoType !== matchVideoType) {
            return null;
        }
        return getPositiveMatchPattern(element);
    };
    function getPositiveMatchPattern(element) {
        const pattern = {
            name: true,
        };
        // This will trigger src consumption (See https://github.com/ckeditor/ckeditor5/issues/11530).
        if (element.hasAttribute('src')) {
            pattern.attributes = ['src'];
        }
        return pattern;
    }
}
/**
 * @internal
 */
export function determineVideoTypeForInsertionAtSelection(schema, selection) {
    const firstBlock = first(selection.getSelectedBlocks());
    if (!firstBlock || schema.isObject(firstBlock)) {
        return 'videoBlock';
    }
    if (firstBlock.isEmpty && firstBlock.name !== 'listItem') {
        return 'videoBlock';
    }
    return 'videoInline';
}
//# sourceMappingURL=utils.js.map